import React from 'react';
import { Link, MenuItem, MenuList, Theme, useMediaQuery } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'i18n';

import { useModal } from 'hooks';

import copyToClipboard from 'utils/copyToClipboard';

import MenuButton from 'components/common/MenuButton';
import CopyUrlSnackbar from 'components/modals/CopyUrlSnackbar';
import socialData from 'components/modals/ShareMenu/socialData';
import CopyUtrIcon from 'components/svg/24px-icon-copy-url.svg';
import { alpha } from '@mui/material/styles';
import { getEventUrl } from './socialData';

interface ShareMenuProps {
  event: any;
  open: boolean;
}

const useStyles = makeStyles()((theme) => ({
  shareMenu: {
    marginTop: theme.spacing(1),
    zIndex: 2000,
  },
  menuItem: {
    // padding: theme.spacing(0, 2),
    minWidth: '193px',
    '&:hover': {
      backgroundColor: alpha(theme.palette.primary.main, 0.07),
    },
  },
}));

const ShareMenu: React.FC<React.PropsWithChildren<ShareMenuProps>> = ({ event, open }) => {
  const { classes } = useStyles();
  const [t] = useTranslation('public');
  const [showCopyUrlSnackbar] = useModal(CopyUrlSnackbar, false);
  const isMobile = useMediaQuery<Theme>((theme) => theme.breakpoints.down('md'));

  const handleCopyUrl = () => {
    copyToClipboard(getEventUrl(event.id));
    showCopyUrlSnackbar();
  };

  return (
    <MenuList autoFocusItem={open}>
      {socialData
        .filter((item) => (isMobile ? item.isMobile : item.isDesktop))
        .map((item) => {
          const shareViaSocial = () => {
            item.share(t, event);
          };
          return item.type === 'SMS' ? (
            <MenuItem
              key={item.id}
              className={classes.menuItem}
              href={event.start_at && (item.share(t, event) as any)}
              underline="none"
              component={Link}
            >
              <MenuButton
                style={{ textTransform: 'capitalize', fontSize: 15, fontWeight: 500 }}
                color="inherit"
                startIcon={item.icon}
                disableFocusRipple
                disableRipple
              >
                {item.type}
              </MenuButton>
            </MenuItem>
          ) : (
            <MenuItem onClick={shareViaSocial} key={item.id} className={classes.menuItem}>
              <MenuButton
                style={{ textTransform: 'capitalize', fontSize: 15, fontWeight: 500 }}
                color="inherit"
                startIcon={item.icon}
                disableFocusRipple
                disableRipple
              >
                {item.type}
              </MenuButton>
            </MenuItem>
          );
        })}
      <MenuItem onClick={handleCopyUrl} className={classes.menuItem}>
        <MenuButton
          style={{ textTransform: 'capitalize', fontSize: 15, fontWeight: 500 }}
          color="inherit"
          disableFocusRipple
          disableRipple
          startIcon={<CopyUtrIcon color="inherit" />}
        >
          {t<string>('common:button.copyUrl')}
        </MenuButton>
      </MenuItem>
    </MenuList>
  );
};

export default ShareMenu;
